<template>
  <div>
    <div class="float" @click="onButtonClick">
      <el-badge :value="chatCount">
        <i class="far fa-comment-alt my-float"></i>
      </el-badge>
    </div>
    <div
      v-show="iframeOpen"
      class="iframe-wrapper"
      id="iframe-wrapper"
      ref="wrapper"
    >
      <div class="iframe-header" id="iframe-header" @mousedown="dragMouseDown">
        <span @click="onButtonClick" class="close-button">
          <i class="fa fa-times"></i>
        </span>
      </div>
      <vue-friendly-iframe
        :src="'https://chat.co-opbank.vn/'"
      ></vue-friendly-iframe>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueFriendlyIframe from "vue-friendly-iframe";
import constants from "../../../constants";
import { Client4 } from "mattermost-redux/client";
Vue.component("vue-friendly-iframe", VueFriendlyIframe.VueFriendlyIframe);
export default {
  name: "chat-button",
  data() {
    return {
      chatCount: 0,
      socketConnected: false,
      iframeOpen: false,
      connection: null,
      currentPost: null,
      positions: {
        clientX: null,
        clientY: null,
        movementX: 0,
        movementY: 0,
      },
    };
  },
  created() {
    let tokenData = JSON.parse(
      localStorage.getItem(constants.STORAGE_KEY.TOKEN_DATA)
    );

    // Kết nối websocket
    if (tokenData["MMAUTHTOKEN"] && tokenData["MMUSERID"] && !this.connection) {
      // Xoá token cũ
      document.cookie = `MMAUTHTOKEN=;domain=.co-opbank.vn;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      document.cookie = `MMUSERID=;domain=.co-opbank.vn;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;

      // Thêm token mới
      document.cookie = `MMAUTHTOKEN=${tokenData["MMAUTHTOKEN"]};domain=.co-opbank.vn;path=/`;
      document.cookie = `MMUSERID=${tokenData["MMUSERID"]};domain=.co-opbank.vn;path=/`;

      const self = this;
      Client4.setUrl("https://chat.co-opbank.vn");
      Client4.setToken(tokenData["MMAUTHTOKEN"]);
      Client4.getMyTeamUnreads()
        .then((res) => {
          if (res && res.length) {
            res.forEach((item) => {
              if (item.msg_count) {
                self.chatCount += parseInt(item.msg_count);
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });

      this.connection = new WebSocket(
        "wss://chat.co-opbank.vn/api/v4/websocket"
      );
      // this.connection = new WebSocket(
      //   "ws://chat.co-opbank.vn/api/v4/websocket"
      // );

      this.connection.onmessage = (event) => this.receiveMessage(event);

      this.connection.onopen = function (event) {
        // console.log(event);
        console.log("Successfully connected to the echo websocket server...");
      };
    }

    // Xin quyền notification
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  },
  beforeDestroy() {
    document.cookie = `MMAUTHTOKEN=;domain=.co-opbank.vn;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    document.cookie = `MMUSERID=;domain=.co-opbank.vn;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    if (this.connection) {
      this.connection.close();
      this.connection = null;
    }
  },
  watch: {
    connection(value) {
      if (value && value.readyState === 1 && !this.socketConnected) {
        let tokenData = JSON.parse(
          localStorage.getItem(constants.STORAGE_KEY.TOKEN_DATA)
        );
        this.connection.send({
          seq: 1,
          action: "authentication_challenge",
          data: {
            token: tokenData["MMAUTHTOKEN"],
          },
        });
      }
    },
  },
  methods: {
    receiveMessage(e) {
      if (e.isTrusted && e.data) {
        const data = JSON.parse(e.data);
        if (data.event === "posted" && data.data.post !== this.currentPost) {
          this.currentPost = data.data.post;
          // this.$message({
          //   message: "Có tin nhắn mới",
          //   type: "success",
          // });
          if (!this.iframeOpen) {
            this.chatCount += 1;
          }
        } else if (data.event === "hello") {
          this.socketConnected = true;
        }
      }
    },
    onButtonClick() {
      this.iframeOpen = !this.iframeOpen;
      this.chatCount = 0;
      // console.log(this.iframeOpen);
    },

    dragMouseDown(e) {
      e.preventDefault();
      this.positions.clientX = e.clientX;
      this.positions.clientY = e.clientY;
      document.onmousemove = this.elementDrag;
      document.onmouseup = this.closeDragElement;
    },

    elementDrag(e) {
      e.preventDefault();
      this.positions.movementX = this.positions.clientX - e.clientX;
      this.positions.movementY = this.positions.clientY - e.clientY;
      this.positions.clientX = e.clientX;
      this.positions.clientY = e.clientY;
      this.$refs.wrapper.style.top =
        this.$refs.wrapper.offsetTop - this.positions.movementY + "px";
      this.$refs.wrapper.style.left =
        this.$refs.wrapper.offsetLeft - this.positions.movementX + "px";
    },

    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
  },
};
</script>

<style scoped>
.float {
  cursor: pointer;
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 50px;
  right: 50px;
  background-color: #0c9;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  z-index: 1000;
}
.my-float {
  margin-top: 20px;
  font-size: 22px;
}
.iframe-wrapper {
  width: 80%;
  height: 80%;
  position: absolute;
  top: 0;
  z-index: 1001;
  border: 1px solid #999;
  display: flex;
  flex-direction: column;
}
.iframe-header {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  cursor: move;
  background-color: #999;
}
.close-button {
  cursor: pointer !important;
}
</style>


// WEBPACK FOOTER //
// src/views/common/layout/chat.vue